import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=09d8d8ea&scoped=true&"
import script from "./BasicModal.vue?vue&type=script&lang=js&"
export * from "./BasicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8d8ea",
  null
  
)

export default component.exports